import { CustomPaymentData } from '../../components/payment/custom-form';

export enum ACCTYPE {
  CHECKING = 'ECHK',
  SAVINGS = 'ESAV',
}

export enum CardConnectPaymentType {
  CC = 'CC',
  ACH = 'ACH',
}
export interface CardConnectApiData
  extends Pick<CustomPaymentData, 'address' | 'address2' | 'city' | 'region'> {
  // address: string;
  country: 'US';
  // We additionally track the payment ID on the transaction
  // to help us link our payment records and the transaction
  // record we can get out of Card Connect
  paymentId: string;
  // This is a reference into a secure Card Connect data
  // store where the card number, expiry, and CVV are stored
  // for a short time so we don't have to handle them
  // directly in our code.
  token: string;
  // Account type is not required for credit cards
  accttype?: ACCTYPE;
  paymentType: CardConnectPaymentType;
  name?: string;
  postal?: string;
}
